import { SupportModel } from '@common/contexts/support/domain/models/supportModel';

export class OutpatientClinicOrganization extends SupportModel {
    public id: string;
    public name: string;

    constructor(options: OutpatientClinicOrganization) {
        super();

        this.id = options.id;
        this.name = options.name;
    }
}
